import React from 'react'
import { Button, Card, CardContent } from '@/shared/ui'
import SlackCredentialsForm from '../components/SlackCredentialsForm'
import WorkspaceCard from '../components/WorkspaceCard'
import { buildSlackOAuthUrl, getSlackAppConfig, listSlackWorkspaces, SlackWorkspace } from '../services/slackService'

export default function SlackSettingsSection() {
  const [cfg, setCfg] = React.useState<{ client_id: string | null; has_secret: boolean }>({ client_id: null, has_secret: false })
  const [workspaces, setWorkspaces] = React.useState<SlackWorkspace[]>([])
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState<string | null>(null)

  async function refresh() {
    setLoading(true)
    setError(null)
    try {
      const c = await getSlackAppConfig()
      setCfg(c)
      const ws = await listSlackWorkspaces()
      setWorkspaces(ws)
    } catch (e:any) {
      setError(e.message || String(e))
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => { refresh() }, [])

  function connectWorkspace() {
    if (!cfg.client_id) return
    const url = buildSlackOAuthUrl(cfg.client_id)
    window.open(url, '_blank', 'noopener,noreferrer,width=700,height=800')
  }

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <h2 className="text-lg font-medium">Credenciais do Slack</h2>
        <p className="text-sm text-foreground/70">Defina as credenciais da App do Slack. O redirect será a Edge Function slack-oauth-callback.</p>
        <SlackCredentialsForm />
      </div>

      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-lg font-medium">Integração Slack</h2>
            <p className="text-sm text-foreground/70">Conecte um ou mais workspaces e selecione os canais para notificação de oportunidades.</p>
          </div>
          <div>
            <Button onClick={connectWorkspace} disabled={!cfg.client_id}>Conectar workspace</Button>
            <Button className="ml-2" onClick={refresh}>Atualizar</Button>
          </div>
        </div>
        {error && <div className="text-sm text-red-500">{error}</div>}
        <div className="space-y-3">
          {workspaces.map(ws => (
            <WorkspaceCard
              key={ws.id}
              workspace={ws}
              onToggleEnabled={(id, enabled) => {
                setWorkspaces(prev => prev.map(w => w.id === id ? { ...w, enabled } : w))
              }}
            />
          ))}
          {workspaces.length === 0 && (
            <Card><CardContent className="pt-4 text-sm text-foreground/60">Nenhum workspace conectado.</CardContent></Card>
          )}
        </div>
      </div>
    </div>
  )
}

